<template>
  <v-container class="pa-0" fluid>
    <div class="pt-4">
      <v-card outlined>
        <v-card-title class="pt-2">
          <h3>{{ $t('Įregistruoti objektai pagal tipą') }}</h3></v-card-title
        >
        <v-card-text>
          <el-overlay-loading dashboard :loading="pageloading" />
          <v-row class="pt-1 pb-3">
            <v-col cols="12" md="6" lg="3">
              <el-autocomplete
                @change="updateBoard()"
                :items="formatedYears"
                direct
                hide-details
                itemvalue="value"
                itemtext="text"
                label="Nuo"
                v-model="formData.from"
              />
            </v-col>
            <v-col cols="12" md="6" lg="3">
              <el-autocomplete
                @change="updateBoard()"
                :items="formatedYears"
                direct
                hide-details
                itemvalue="value"
                itemtext="text"
                label="Iki"
                v-model="formData.to"
              />
            </v-col>
            <v-col cols="12" md="6" lg="3">
              <el-autocomplete
                @change="updateBoard()"
                :items="formatedTerms"
                enums
                hide-details
                itemvalue="value"
                itemtext="text"
                label="Žingsnis"
                v-model="formData.period"
              />
            </v-col>
            <v-col cols="12" md="6" lg="3">
              <!-- <export-btn object="registered-type" :id="chartId"></export-btn> -->
            </v-col>
          </v-row>
          <v-divider />
          <v-row class="pt-1 pb-3">
            <v-col cols="12">
              <LineChartGenerator
                :chart-options="chartOptions"
                :chart-data="chartData"
                :chart-id="chartId"
                :dataset-id-key="datasetIdKey"
                :plugins="plugins"
                :css-classes="cssClasses"
                :styles="styles"
                :width="width"
                :height="height"
              />
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </div>
  </v-container>
</template>

<script>
import { Line as LineChartGenerator } from 'vue-chartjs/legacy'
import Enums from '@/enums'

import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  LineElement,
  LinearScale,
  CategoryScale,
  PointElement,
} from 'chart.js'

ChartJS.register(
  Title,
  Tooltip,
  Legend,
  LineElement,
  LinearScale,
  CategoryScale,
  PointElement
)

const customLabels = {
  id: 'customLabels',
  afterDatasetsDraw: (chart, args, opts) => {
    const ctx = chart.ctx
    const datasets = chart.data.datasets

    datasets.forEach((dataset, datasetIndex) => {
      const meta = chart.getDatasetMeta(datasetIndex)
      if (!meta.hidden) {
        meta.data.forEach((element, index) => {
          const dataPoint = dataset.data[index] || ''
          const x = element.x
          const y = element.y

          ctx.fillStyle = 'black' // Customize label color
          ctx.font = '10px Arial' // Change font size to 10
          ctx.textAlign = 'center'
          ctx.fillText(dataPoint, x, y - 10) // Display dataPoint value above the bar
        })
      }
    })
  },
}

const customTitle = {
  id: 'customTitle',
  afterDraw: (chart, args, opts) => {
    const {
      ctx,
      chartArea: { top },
    } = chart

    if (opts.y.display) {
      ctx.fillStyle = opts.y.color || ChartJS.defaults.color
      ctx.fillText(
        opts.y.text,
        opts.y.offsetX || 50,
        top + (opts.y.offsetY * -1 || -15)
      )
    }
  },
}

export default {
  name: 'RegisteredTypeForm',
  components: {
    LineChartGenerator,
  },
  data() {
    return {
      formData: {},
      pageloading: false,
      //
      chartData: {},
      chartOptions: {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          y: {
            ticks: {
              callback: function (value) {
                return value.toString()
              },
            },
          },
        },
        plugins: {
          tooltip: {
            callbacks: {
              label: function (context) {
                let label = context.dataset.label || ''
                if (label) {
                  label += ': '
                }
                if (context.parsed.y !== null) {
                  label += context.parsed.y.toString()
                }
                return label
              },
            },
          },
          customTitle: {
            y: {
              display: true,
              text: 'Įregistravimo skaičius',
            },
          },
          customLabels: {
            display: true,
          },
        },
      },
      //
      chartId: 'registered-type-chart',
      datasetIdKey: 'label',
      width: 400,
      height: 200,
      cssClasses: '',
      styles: {},
      plugins: [customTitle, customLabels],
    }
  },
  computed: {
    formatedTerms() {
      return Enums.filterStep
    },
    formatedYears() {
      let years = []
      let year = new Date().getFullYear()
      while (year >= 2010) {
        years.push(year.toString())
        year--
      }
      return years
    },
  },
  created() {
    this.$set(this.formData, 'from', (new Date().getFullYear() - 1).toString())
    this.$set(this.formData, 'to', new Date().getFullYear().toString())
    this.$set(this.formData, 'period', 'months3')

    this.getData()
  },
  methods: {
    getData() {
      this.pageloading = true

      this.$axios
        .post(`dashboard/type`, this.formData)
        .then((res) => {
          this.chartData = {
            labels: res.data.labels,
            datasets: [
              {
                label: 'NTPĮ',
                backgroundColor: 'rgba(0, 76, 76, 1)',
                borderColor: 'rgba(0, 76, 76, 1)',
                data: res.data.data.NTPI,
                //cubicInterpolationMode: 'monotone',
              },
              {
                label: 'ĮTPSĮ',
                backgroundColor: 'rgba(255, 153, 102, 1)',
                borderColor: 'rgba(255, 153, 102, 1)',
                data: res.data.data.ITPSI,
                //cubicInterpolationMode: 'monotone',
              },
              {
                label: 'Prokūros',
                backgroundColor: 'rgba(178, 216, 216, 1)',
                borderColor: 'rgba(178, 216, 216, 1)',
                data: res.data.data.PP,
                //cubicInterpolationMode: 'monotone',
              },
            ],
          }
          this.pageloading = false
        })
        .catch((err) => {
          this.$root.$emit('DATA_ERROR', err)
          this.pageloading = false
        })
    },
    updateBoard() {
      this.getData()
    },
  },
}
</script>
<style lang="scss" scoped></style>
